"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/ChatHeader/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _user = require('shared/selectors/user');
var _conversation = require('shared/selectors/conversation');
var _blobject = require('shared/selectors/blobject');







var _translation = require('shared/selectors/translation');
var _chat = require('shared/enum/chat');
var _requests = require('shared/selectors/requests');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _hooks = require('web/services/hooks');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _chat3 = require('shared/hooks/chat');
var _hooks3 = require('../hooks');

var _renderChatDesc = require('./renderChatDesc');
var _RenameChatModal = require('../RenameChatModal'); var _RenameChatModal2 = _interopRequireDefault(_RenameChatModal);
var _ExportChatModal = require('../ExportChatModal'); var _ExportChatModal2 = _interopRequireDefault(_ExportChatModal);
var _ArchiveModal = require('../ArchiveModal'); var _ArchiveModal2 = _interopRequireDefault(_ArchiveModal);
var _Tooltip = require('web/components/Tooltip');





var _Header = require('web/components/RightSide/Header');
var _NotificationPreferenceModal = require('../NotificationPreferenceModal'); var _NotificationPreferenceModal2 = _interopRequireDefault(_NotificationPreferenceModal);
var _InboxItemAvatar = require('../InboxItemAvatar'); var _InboxItemAvatar2 = _interopRequireDefault(_InboxItemAvatar);
var _InsecureTextTag = require('web/components/SecureText/InsecureTextTag'); var _InsecureTextTag2 = _interopRequireDefault(_InsecureTextTag);
var _KeywordChip = require('web/components/Requests/KeywordChip'); var _KeywordChip2 = _interopRequireDefault(_KeywordChip);
var _LanguageModal = require('../LanguageModal'); var _LanguageModal2 = _interopRequireDefault(_LanguageModal);
var _TranslationOffDialog = require('web/components/Conversation/TranslationOffDialog'); var _TranslationOffDialog2 = _interopRequireDefault(_TranslationOffDialog);

/* The line under "Language": the patient's language ("Vietnamese", or
 * "Vietnamese · translation off" when it is saved but not translating), or in
 * a household each patient with a language, by name. Undefined while none is
 * set. */
const languageDesc = (translation) => {
  const patients = _translation.getChatPatients.call(void 0, translation)
  if (patients.length > 1) {
    return patients
      .filter(patient => patient.Language)
      .map(patient => `${patient.Name}: ${_translation.patientLanguageLabel.call(void 0, patient)}`)
      .join(', ') || undefined
  }
  return _optionalChain([patients, 'access', _ => _[0], 'optionalAccess', _2 => _2.Language]) ? _translation.patientLanguageLabel.call(void 0, patients[0]) : undefined
}









const ChatHeader = ({
  blobjectKey,
  rightPaneOpen,
  onToggleRightPane,
  searchPaneOpen,
  onToggleSearchPane,
}) => {
  const chatName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_blobject.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _3 => _3.Name]), () => ( '')))
  const conversationKey = _hooks.useAppSelector.call(void 0, state => _optionalChain([_blobject.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _4 => _4.WrappedKey]))
  const conversationType = _hooks.useAppSelector.call(void 0, state => _optionalChain([_blobject.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _5 => _5.WrappedType]))
  const myUserKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const requestKeywords = _hooks.useAppSelector.call(void 0, state => _requests.selectOpenRequestKeywordsByConversationKey.call(void 0, state, conversationKey))
  const displayParticipants = _hooks.useAppSelector.call(void 0, state => _conversation.selectDisplayChatParticipants.call(void 0, state, blobjectKey))
  const hasMyTeams = _hooks.useAppSelector.call(void 0, 
    state => _blobject.selectMyBlobjectTeamSubscribers.call(void 0, state, blobjectKey).length > 0,
  )
  // "Language" shows where the patients' languages can be set; its line
  // under the label names them once one is (a string, so the header
  // re-renders only when it changes).
  const showLanguage = _hooks.useAppSelector.call(void 0, state => !!conversationKey &&
    _translation.shouldShowTranslationControls.call(void 0, _translation.selectConversationTranslation.call(void 0, state, conversationKey)))
  // With the org's translation off, Language explains that instead.
  const isOrgOff = _hooks.useAppSelector.call(void 0, state => showLanguage &&
    _translation.isLanguageOffForOrg.call(void 0, _translation.selectConversationTranslation.call(void 0, state, conversationKey)))
  const patientLanguage = _hooks.useAppSelector.call(void 0, state => conversationKey
    ? languageDesc(_translation.selectConversationTranslation.call(void 0, state, conversationKey))
    : undefined)

  const {
    isOpen: isNotificationsModalOpen,
    onOpen: onOpenNotificationsModal,
    onClose: onCloseNotificationsModal,
  } = _useToggle2.default.call(void 0, )

  const {
    isOpen: isRenameModalOpen,
    onOpen: onOpenRenameModal,
    onClose: onCloseRenameModal,
  } = _useToggle2.default.call(void 0, )

  const {
    isOpen: isExportModalOpen,
    onOpen: onOpenExportModal,
    onClose: onCloseExportModal,
  } = _useToggle2.default.call(void 0, )

  const {
    isOpen: isLanguageModalOpen,
    onOpen: onOpenLanguageModal,
    onClose: onCloseLanguageModal,
  } = _useToggle2.default.call(void 0, )

  const {
    isOpen: isTranslationOffOpen,
    onOpen: onOpenTranslationOff,
    onClose: onCloseTranslationOff,
  } = _useToggle2.default.call(void 0, )

  const onLanguage = _react.useCallback.call(void 0, 
    () => isOrgOff ? onOpenTranslationOff() : onOpenLanguageModal(),
    [isOrgOff, onOpenTranslationOff, onOpenLanguageModal],
  )

  const {
    isOpen: isArchiveModalOpen,
    onOpen: onOpenArchiveModal,
    onClose: onCloseArchiveModal,
  } = _useToggle2.default.call(void 0, )

  const chatDesc =
    _chat3.useChatDesc.call(void 0, { displayParticipants, myUserKey, renderChatDesc: _renderChatDesc.renderChatDesc })
  const onExport = _hooks3.useExportChat.call(void 0, { conversationKey })

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_NotificationPreferenceModal2.default, {
        isOpen: isNotificationsModalOpen,
        onClose: onCloseNotificationsModal,
        blobjectKey: blobjectKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}}
      )
      , _react2.default.createElement(_RenameChatModal2.default, {
        isOpen: isRenameModalOpen,
        blobjectKey: blobjectKey,
        onClose: onCloseRenameModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}
      )
      , _react2.default.createElement(_ExportChatModal2.default, {
        isOpen: isExportModalOpen,
        onClose: onCloseExportModal,
        onProceed: onExport, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}
      )
      , _react2.default.createElement(_ArchiveModal2.default, {
        blobjectKey: blobjectKey,
        isOpen: isArchiveModalOpen,
        onClose: onCloseArchiveModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
      )
      ,  conversationKey && (
        _react2.default.createElement(_LanguageModal2.default, {
          conversationKey: conversationKey,
          // Closes if translation goes off while it's open: its commands
          // would be refused.
          isOpen: isLanguageModalOpen && showLanguage && !isOrgOff,
          onClose: onCloseLanguageModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}
        )
      )
      ,  conversationKey && (
        _react2.default.createElement(_TranslationOffDialog2.default, {
          conversationKey: conversationKey,
          isOpen: isTranslationOffOpen,
          onClose: onCloseTranslationOff, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}}
        )
      )

      , _react2.default.createElement(_Header.HeaderMobileBackButton, { onClick: _actions2.default.gotoInbox, __self: this, __source: {fileName: _jsxFileName, lineNumber: 177}} )
      , _react2.default.createElement(_InboxItemAvatar2.default, { bkey: blobjectKey, size: 40, borderColor: "var(--bg-surface)", __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}} )
      , _react2.default.createElement(_Header.RightSideHeaderHeading, {
        title: chatName,
        subtitle: chatDesc,
        titleBadge: conversationType === _chat.CHAT_TYPE.REGULAR_PATIENT || requestKeywords.length
          ? (
              _react2.default.createElement(_react2.default.Fragment, null
                ,  conversationType === _chat.CHAT_TYPE.REGULAR_PATIENT && (
                  _react2.default.createElement(_InsecureTextTag2.default, { className: "inbox-header--insecure-tag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 186}} )
                )
                ,  requestKeywords.map(keyword => (
                  _react2.default.createElement(_KeywordChip2.default, { key: keyword, keyword: keyword, className: "inbox-header--keyword-chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}} )
                ))
              )
            )
          : null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}
      )

      , _react2.default.createElement(_Header.HeaderItem, {
        iconName: "search",
        'aria-label': "Search this conversation"  ,
        onClick: onToggleSearchPane,
        selected: searchPaneOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}}
      )
      , _react2.default.createElement(_Header.HeaderItem, {
        iconName: "inbox-sidebar",
        className: "blmh-mobile-hide",
        'aria-label': "View participants" ,
        onClick: onToggleRightPane,
        selected: rightPaneOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 202}}
      )

      , _react2.default.createElement(_Header.HeaderMoreToggle, { className: "inbox-header--more-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}}
        , _react2.default.createElement(_Tooltip.TooltipMenuItem, {
          iconSrc: "/assets/icons/header/bell-dark.svg",
          label: "Manage notifications" ,
          onClick: onOpenNotificationsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}
        )
        ,  conversationType !== _chat.CHAT_TYPE.REGULAR_PATIENT && (
          _react2.default.createElement(_Tooltip.TooltipMenuItem, {
            iconSrc: "/assets/icons/header/edit-dark.svg",
            label: "Rename this chat"  ,
            onClick: onOpenRenameModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}
          )
        )
        ,  showLanguage && (
          _react2.default.createElement(_Tooltip.TooltipMenuItem, {
            iconSrc: "/assets/icons/header/translate-dark.svg",
            label: "Language",
            desc: patientLanguage,
            onClick: onLanguage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}}
          )
        )
        , _react2.default.createElement(_Tooltip.TooltipMenuItem, {
          className: "blmh-desktop-hide",
          iconSrc: "/assets/icons/header/inbox-sidebar-dark.svg",
          label: "View participants" ,
          onClick: onToggleRightPane, __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}}
        )
        , _react2.default.createElement(_Tooltip.TooltipMenuItem, {
          iconSrc: "/assets/icons/icon-download-dark-grey.svg",
          label: "Export this chat"  ,
          onClick: onOpenExportModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}}
        )
        ,  hasMyTeams && (
          _react2.default.createElement(_Tooltip.TooltipMenuItem, {
            iconSrc: "/assets/icons/icon-completed-dark-grey.svg",
            label: "Archive for..." ,
            iconClassName: "inbox-header--complete-icon",
            onClick: onOpenArchiveModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 243}}
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ChatHeader)
